module.exports = __webpack_public_path__ + "img/power-sharing.130b6ade.png";